import API_BASE_URL from '../Config';

export const getEstadosSocio = async (token) => {
    const response = await fetch(`${API_BASE_URL}/estados-socio`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar estados de socio');
    return response.json();
};

export const getEstadosSocioPaginados = async (token, page = 0, size = 10, search = '') => {
    const url = new URL(`${API_BASE_URL}/estados-socio/page`);
    url.searchParams.append('page', page);
    url.searchParams.append('size', size);
    if (search) url.searchParams.append('search', search);

    const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar estados de socio paginados');
    return response.json();
};

export const getEstadoSocioById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/estados-socio/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar el estado de socio');
    return response.json();
};

export const createEstadoSocio = async (token, data) => {
    const response = await fetch(`${API_BASE_URL}/estados-socio`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear el estado de socio');
    return response.json();
};

export const updateEstadoSocio = async (token, id, data) => {
    const response = await fetch(`${API_BASE_URL}/estados-socio/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar el estado de socio');
    return response.json();
};

export const darDeBajaEstadoSocio = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/estados-socio/${id}/dar-baja`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al dar de baja el estado de socio');
};

export const deleteEstadoSocio = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/estados-socio/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar el estado de socio');
};
